import { DatePeriod } from 'Constants/Global'

export enum WidgetNames {
	ORDERS = 'total_orders',
	ORDERS_TREND = 'orders_chart',
	REWARD = 'reward',
	DEAL = 'deals',
	DEAL_TREND = 'deals_chart',
	CONVERSION = 'conversion',
	PARTNERS_DEAL_RATING = 'partners_rating',
	EMPLOYEE_STATISTIC = 'employee',
	UNPAID_ACTS = 'unpaid_acts',
	CAPABILITIES = 'capabilities',
	BG_AMOUNTS = 'bg_amounts',
	BG_REWARDS = 'bg_rewards',
	REFERAL_LINKS = 'referal_links',
	PARTNER_CERTIFICATE = 'partner_certificate',
}

export const WidgetNamesTranslations = {
	[WidgetNames.ORDERS]: 'Заявки',
	[WidgetNames.ORDERS_TREND]: 'Динамика заявок',
	[WidgetNames.REWARD]: 'Вознаграждения',
	[WidgetNames.DEAL]: 'Сделки',
	[WidgetNames.DEAL_TREND]: 'Динамика сделок',
	[WidgetNames.CONVERSION]: 'Конверсия',
	[WidgetNames.PARTNERS_DEAL_RATING]: 'Рейтинг партнеров по сделкам',
	[WidgetNames.EMPLOYEE_STATISTIC]: 'Эффективность сотрудников',
	[WidgetNames.UNPAID_ACTS]: 'Акты',
	[WidgetNames.CAPABILITIES]: 'Возможности',
	[WidgetNames.BG_AMOUNTS]: 'Банковские гарантии',
	[WidgetNames.BG_REWARDS]: 'Программа мотивации по БГ',
	[WidgetNames.REFERAL_LINKS]: 'Реферальные ссылки',
	[WidgetNames.PARTNER_CERTIFICATE]: 'Сертификат партнера',
}

export enum WidgetSize {
	SMALL = 6,
	MIDDLE = 12,
	LARGE = 24,
}

export const Widgets = [
	[
		{
			name: WidgetNames.ORDERS,
			title: WidgetNamesTranslations[WidgetNames.ORDERS],
			size: WidgetSize.SMALL,
		},
		{
			name: WidgetNames.ORDERS_TREND,
			title: WidgetNamesTranslations[WidgetNames.ORDERS_TREND],
			size: WidgetSize.SMALL,
		},
		{
			name: WidgetNames.REWARD,
			title: WidgetNamesTranslations[WidgetNames.REWARD],
			size: WidgetSize.SMALL,
		},
		{
			name: WidgetNames.BG_AMOUNTS,
			title: WidgetNamesTranslations[WidgetNames.BG_AMOUNTS],
			size: WidgetSize.MIDDLE,
		},
		{
			name: WidgetNames.BG_REWARDS,
			title: WidgetNamesTranslations[WidgetNames.BG_REWARDS],
			size: WidgetSize.MIDDLE,
		},
	],
	[
		{
			name: WidgetNames.DEAL,
			title: WidgetNamesTranslations[WidgetNames.DEAL],
			size: WidgetSize.SMALL,
		},
		{
			name: WidgetNames.DEAL_TREND,
			title: WidgetNamesTranslations[WidgetNames.DEAL_TREND],
			size: WidgetSize.SMALL,
		},
		{
			name: WidgetNames.CONVERSION,
			title: WidgetNamesTranslations[WidgetNames.CONVERSION],
			size: WidgetSize.SMALL,
		},
		{
			name: WidgetNames.UNPAID_ACTS,
			title: WidgetNamesTranslations[WidgetNames.UNPAID_ACTS],
			size: WidgetSize.SMALL,
		},
	],
	[
		{
			name: WidgetNames.CAPABILITIES,
			title: WidgetNamesTranslations[WidgetNames.CAPABILITIES],
			size: WidgetSize.MIDDLE,
		},
		{
			name: WidgetNames.PARTNERS_DEAL_RATING,
			title: WidgetNamesTranslations[WidgetNames.PARTNERS_DEAL_RATING],
			size: WidgetSize.MIDDLE,
		},
		{
			name: WidgetNames.EMPLOYEE_STATISTIC,
			title: WidgetNamesTranslations[WidgetNames.EMPLOYEE_STATISTIC],
			size: WidgetSize.MIDDLE,
		},
		{
			name: WidgetNames.REFERAL_LINKS,
			title: WidgetNamesTranslations[WidgetNames.REFERAL_LINKS],
			size: WidgetSize.MIDDLE,
		},
		{
			name: WidgetNames.PARTNER_CERTIFICATE,
			title: WidgetNamesTranslations[WidgetNames.PARTNER_CERTIFICATE],
			size: WidgetSize.MIDDLE,
		},
	],
]

export const DefaultPeriod = DatePeriod.MONTH
export const WidgetsWithForecast = [
	WidgetNames.ORDERS,
	WidgetNames.DEAL,
	WidgetNames.BG_AMOUNTS,
	WidgetNames.BG_REWARDS,
	WidgetNames.PARTNERS_DEAL_RATING,
]
export const WidgetsWithFilters = [
	...WidgetsWithForecast,
	WidgetNames.ORDERS_TREND,
	WidgetNames.DEAL_TREND,
	WidgetNames.EMPLOYEE_STATISTIC,
]
export const WidgetsAll = [
	...WidgetsWithFilters,
	WidgetNames.UNPAID_ACTS,
	WidgetNames.CAPABILITIES,
	WidgetNames.REWARD,
	WidgetNames.REFERAL_LINKS,
]
export const WidgetsNewDesign = [
	WidgetNames.BG_AMOUNTS,
	WidgetNames.BG_REWARDS,
	WidgetNames.PARTNER_CERTIFICATE,
	WidgetNames.CAPABILITIES,
	WidgetNames.REFERAL_LINKS,
]

export const OTHER_GROUP_NAME = 'Прочее'

export const capabilitiesModalTableHeader = ['Продукт', 'Кол-во', 'Стоимость', 'Сумма']

export const QrCodeQuality = 1080
